<template>
	<view class="comment">
		<view class="store_remak">
			<view class="list">
				<view class="list_item" v-for="(item, index) in 3" :key="index">
					<view class="list_item_head">
						<image src="@/static/logo.png" mode="widthFix"></image>
						<text>木**王</text>
					</view>
					<view class="list_pf">
						<uni-rate :value="5" size="18" color="#bbb" active-color="red" />
					</view>
					<view class="list_wz">
						能用这个价位买到这样的质量真心值啦，做工精致用料
						实在讲究，商家用心喽，不说价位质量与几百相比没什
						么区别，值得购入！
					</view>
					<view class="list_imgs">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<image src="@/static/uni.png" mode="widthFix"></image>
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="list_zan">
						<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
						<text>2</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.comment {
		width: 100%;
		.store_remak {
			width: 100%;
			padding: 28rpx 30rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			.list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 24rpx;
				.list_item {
					display: flex;
					flex-direction: column;
					margin-bottom: 32rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					.list_pf {
						width: 100%;
						margin: 22rpx 0 24rpx 0;
					}
					.list_wz {
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #000000;
					}
					.list_imgs {
						width: 100%;
						margin-top: 24rpx;
						display: flex;
						align-items: center;
						image {
							width: 220rpx;
							height: 220rpx;
							margin-right: 12rpx;
							&:last-child {
								margin-right: 0 !important;
							}
						}
					}
					.list_zan {
						display: flex;
						align-items: center;
						justify-content: flex-end;
						margin-top: 22rpx;
						image {
							width: 30rpx;
							height: 30rpx;
							margin-right: 6rpx;
						}
						text {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
					.list_item_head {
						display: flex;
						align-items: center;
						image {
							width: 64rpx;
							height: 64rpx;
							border-radius: 50%;
							margin-right: 12rpx;
						}
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>